import React, { ReactNode } from "react";
import {
  BoldOutlined,
  HighlightOutlined,
  ItalicOutlined,
  OrderedListOutlined,
  UnderlineOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";

export type TextEditorIconType =
  | "Bold"
  | "Italic"
  | "Underline"
  | "Highlight"
  | "UnorderedList"
  | "OrderedList";
export const TextEditorIcons: Record<TextEditorIconType, ReactNode> = {
  Bold: <BoldOutlined />,
  Italic: <ItalicOutlined />,
  Underline: <UnderlineOutlined />,
  Highlight: <HighlightOutlined />,
  UnorderedList: <UnorderedListOutlined />,
  OrderedList: <OrderedListOutlined />,
};
